export default (cart, activatedProduct) => ({
	event: 'productActivation',
	eventCategory: 'Ecommerce',
	eventLabel: activatedProduct.id,
	eventAction: activatedProduct.fulfillment.activation.status,
	activations: activatedProduct.fulfillment.activation.successCount,
	fActivations: activatedProduct.fulfillment.activation.failCount,
	orderId: cart.order.id,
	contentGroup: cart.order.contentGroup
});
